import axios from 'axios';

export const INTEGRATION_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
};

export default {
  namespaced: true,
  state: {
    integrationStatus: INTEGRATION_STATUS.DISCONNECTED,
    error: "",
    loaded: false,
  },
  getters: {
    isIntegrationConnected: state => {
      return state.integrationStatus === INTEGRATION_STATUS.CONNECTED;
    },
  },
  mutations: {
    setIntegrationStatus(state, status) {
      state.integrationStatus = status;
    },
    setError(state, error) {
      state.error = error;
    },
    setLoaded(state, value) {
      state.loaded = value;
    },
  },
  actions: {
    async getIntegrationStatus({ dispatch, commit, rootState }, forceUpdate = false) {
      try {
        if (!rootState.integrations.loaded || forceUpdate) {
          await dispatch('integrations/getIntegrations', null, { root: true });
        }
        let integrations = rootState.integrations.integrations;
        const integration = integrations.find(n => n.name === 'LeadsPlus');
        if (integration) {
          return commit('setIntegrationStatus', integration.status);
        }
      } catch (error) {
        commit('setError', error);
      } finally {
        commit('setLoaded', true);
      }
    },
  },
};
